import React from 'react';
import './style.scss'
import {Button} from "antd";

const PaymentAgreementTermsAndConditions = () => {
    return (
        <div className="PaymentAgreement-terms-conditions-container">
            <p><strong>Textura and Vieunite Pro Subscription Terms and Conditions</strong></p>
            <p> This tells you information about us and the legal terms and conditions ("Terms") on which the Textura
                products and Vieunite Pro subscription services ("Products" and "Services")
                listed on our website(http://192.168.1.140/business) and any associated digital platform which may be
                released by us from time to time(together, the "Platform") are offered for sale to you.</p>
            <p>For ease of reading, we have divided these Terms into several sections:</p>

            <ul>
                <li>INTRODUCTION</li>
                <li>CONTRACT PARTIES</li>
                <li>HOW TO CONTACT US</li>
                <li>ORDERS</li>
                <li>PRODUCTS AND SERVICES</li>
                <li>PRICING</li>
                <li>PAYMENT</li>
                <li>DELIVERY & INSURANCE</li>
                <li>ARTWORK</li>
                <li>YOUR RIGHTS TO RETURN PRODUCTS</li>
                <li>FAULTY PRODUCTS</li>
                <li>YOUR RIGHTS TO CANCEL SERVICES</li>
                <li>OUR LIABILITY</li>
                <li>OTHER IMPORTANT TERMS</li>
            </ul>
            <section>
                <p>INTRODUCTION</p>
                <p>These Terms will apply to any contract for the sale of Products and Services which you enter into
                    using the Platform (each a "Contract").
                    Please read these Terms carefully before ordering any Products and Services from our Platform.
                    By placing an order on our Platform, you agree to be bound by these Terms, as well as any general
                    terms and conditions of use,
                    which may be published on the Platform from time to time.</p>
                <p>Every time you wish to order a Product and Service, please check these Terms as we may have made
                    changes to them since your last order and the Terms in force at the date of each order will apply.
                    We reserve the right to amend these Terms at any time.</p>
            </section>
            <section>
                <p>CONTRACT PARTIES</p>
                <p>“We”, “us”, “our”, “Vieunite” are Vieunite Limited, a company registered in England and Wales under
                    company number 13883746,
                    with our registered office at Allsee Building, 38 Kettles Wood Drive, Birmingham, United Kingdom,
                    B32 3DB.</p>
                <p>“You”, “your”, “yours” are the person who buys or agrees to buy Products and Services on the Platform
                    from us.</p>
                <p>No terms under this document shall be bound by the provisions under the Contracts (Rights of Third
                    Parties) Act 1999 unless provisions hereinunder explicitly state otherwise.</p>
                <p>"Account" means our records of any information which you have supplied to us. This includes
                    information about you;
                    details of your service subscribed (“Subscription Plan”), and details of your use of our
                    Services.</p>
                <p>”Administration Fee” means any charge which Vieunite may levy under this Contract in specified
                    circumstances for the cost of additional and/or customized services to you;</p>
                <p>“Contract” means these General Terms and Conditions and where applicable the order form, Charges,
                    Price Sheet, Subscription Plan, our Code of Practice, the Subscription Terms and Conditions the
                    Terms and Conditions;</p>
                <p>"Charges" means all sums payable to us for the purchase of Products and Services which we make
                    available to you as described in the Price Sheet, including any Administration Fees;</p>
                <p>“Code of Practice” means the Vieunite Pro’s code of practice detailing our method of dealing with any
                    complaints or disputes relating to our Products and Services, which can be found at
                    www.vieunite.com/business</p>
                <p>"Content" means any text, visual or other information, software, photos, video, graphics, sound and
                    other material appearing on or available through the Services for use on our Products or otherwise,
                    including any information supplied from time to time for which Vieunite has the Rights to resell or
                    allows a supplier of such Content to provide them via our portal network;</p>
                <p>“Credit Card” and/or “Debit Card” mean a card issued by a UK or overseas bank in your name from which
                    we are able to take payments under this Contract directly or via our partners;</p>
                <p>“Customer Services” means the Vieunite staff and employees allocated to respond and assist customers
                    with any queries and complaints.
                    We are contactable via Vieunite’s telephone numbers, by WhatsApp Business, by email or in
                    writing;</p>
                <p>“Code of Practice” means the Vieunite Pro’s code of practice detailing our method of dealing with any
                    complaints or disputes relating to our Products and Services, which can be found at
                    www.vieunite.com/business</p>
                <p>“Day” means the period from 00:00 to 23:59;</p>
                <p>“Intellectual Property” or “IP” means any intellectual property rights anywhere in the world whether
                    registerable or not,
                    including, without limitation, patents, trademarks, service marks, designs, copyrights and related
                    rights, database rights, know-how, moral rights and domain names,
                    as well as applications for registration of such rights and the right to apply for registrations,
                    and all equivalent or similar forms of protection notwithstanding the manner in which they arise or
                    in which media;</p>
                <p>“Minimum Term” means the minimum specified period of time for which you have entered into a Contract
                    with us and as specified as part of your Subscription Plan and on which the prices of your plans are
                    based;</p>
                <p>“Month” means a calendar month from the date of any event under this Contract;</p>
                <p>“Product” means any Textura digital canvas supplied to you by us.
                    Please note any leased Product is provided to you under license and it remains our property. We
                    require you to return it at the end of the license;</p>
                <p>“Price Plan” includes any applicable conditions relating to the prices and Charges for the provision
                    of your Vieunite Pro annual subscription plans;</p>
                <p>“Privacy Policy” means the Vieunite policy on controlling your information which can be found at
                    www.vieunite.com/business/privacy;</p>
                <p>"Register" and "Registration" means our acceptance of your application to register your details with
                    us for the Service once you purchase solutions from us;</p>
                <p>"Rights" means copyright, trademark and other relevant proprietary and intellectual property rights
                    relating to Content;</p>
                <p>"Service" means any of the Vieunite Pro Subscription Plans available for use by you via our
                    Platform;</p>
                <p>"User Guide(s)" means any guides or documentation supplied with your Textura and Vieunite Pro
                    Platform
                    that explain to you how the Service works, how to purchase content and/or how to use your
                    Textural;</p>
            </section>
            <section>
                <p>HOW TO CONTACT US</p>
                <p>When we refer,in these Terms, to "inwriting",this will include e-mail.</p>
                <p>If you have any questions or complain about the Products or these Terms, these should be sent to us
                    at <a
                        href="mailto:support@vieunite.com"
                        style={{color: 'black', textDecoration: 'underline'}}>support@vieunite.com</a> or by mail to
                    VieuniteLimited at Allsee Building, 38 Kettles Wood Drive,
                    Birmingham, United Kingdom,
                    B32 3DB. If we have to contact you, we may do so by telephone, or by writing to you at the e-mail
                    address or postal address you have provided to us at the time you place your order.</p>
            </section>
            <section>
                <p>ORDERS</p>
                <p>How we will accept your order</p>
                <p>By placing an order, you are offering to purchase a Product and Service in accordance with these
                    Terms and Conditions.
                    After you place an order for a Product and Service, you will receive an e-mail from us acknowledging
                    and confirming your order.At which point, a binding contract will have come into existence between
                    you and us.
                    We recommend that you print a copy of that order confirmation for your records.</p>
                <p>If you have an issue placing an order,please contact us at <a
                    href="mailto:support@vieunite.com" style={{ color: 'black', textDecoration: 'underline' }}>support@vieunite.com</a></p>
            </section>
            <Button className="PaymentAgreementButton" onClick={() => window.close()}>Close</Button>
        </div>
    );
};

export default PaymentAgreementTermsAndConditions;
